import { IResourceModel } from "../abstraction";

// Objet permettant une gestion des différentes images de l'application (images)
export class ResourceManager {
    constructor() {
    }

    private _images: IResourceModel[] = [];
    public get imgBank() {
        return this._images;
    }

    public set imgBank(bank: IResourceModel[]) {
        this._images = bank;
    }

    public getImg = (code: string) => {
        if (this.imgBank == undefined) return "";
        if (code) {
            let r = this.imgBank.find(x => x.code.toLowerCase() == code.toLowerCase());
            if (r !== undefined) {
                return r.data;
            }
        }
        return "";
    }   
}

